// extracted by mini-css-extract-plugin
module.exports = {"cDesc":"cDesc___38-DI"};